<mat-form-field>
    <input [formControl]="search" spellcheck="false" matInput placeholder="Search by name">
</mat-form-field>